import React from 'react'
import { defineMessages, injectIntl } from 'react-intl'
import Alerts from "../alerts/Alerts";
import Translation from '../global/Translation'

defineMessages({
   /*  user_center_placeholder: {
        id: 'user_center_placeholder',
        description: 'user_center_placeholder',
        defaultMessage: 'User center'
    }, */
    email_user_center_placeholder: {
        id: 'email_user_center_placeholder',
        description: 'email_user_center_placeholder',
        defaultMessage: 'Email center'
    },
    add_account: {
        id: 'add_account',
        description: 'add_account',
        defaultMessage: 'Add account'
    },
    add_user_center: {
        id: 'add_user_center',
        description: 'add_user_center',
        defaultMessage: 'Add center user'
    },
    EMAIL_ERROR_CENTER: {
        id: 'EMAIL_ERROR_CENTER',
        description: 'EMAIL_ERROR_CENTER',
        defaultMessage: 'The email is incorrect, it has to be @cosentino.com'
    },
    EMAIL_EXISTS_CENTER: {
        id: 'EMAIL_EXISTS_CENTER',
        description: 'EMAIL_EXISTS_CENTER',
        defaultMessage: 'This email is already registered in the center'
    },
    SUCCESS_EMAIL_CENTER: {
        id: 'SUCCESS_EMAIL_CENTER',
        description: 'SUCCESS_EMAIL_CENTER',
        defaultMessage: 'Email registered in the center'
    },
    EMAIL_CENTER_IS_NOT_FORMAT: {
        id: 'EMAIL_CENTER_IS_NOT_FORMAT',
        description: 'EMAIL_CENTER_IS_NOT_FORMAT',
        defaultMessage: 'The email has to be @cosentino.com'
    },
    EMAIL_CENTER_NOT_EMPTY: {
        id: 'EMAIL_CENTER_NOT_EMPTY',
        description: 'EMAIL_CENTER_NOT_EMPTY',
        defaultMessage: 'The email cannot be empty'
    },
    USER_CENTER_NOT_EMPTY: {
        id: 'USER_CENTER_NOT_EMPTY',
        description: 'USER_CENTER_NOT_EMPTY',
        defaultMessage: 'The user cannot be left empty'
    },
    USER_CENTER_INVALID: {
        id: 'USER_CENTER_INVALID',
        description: 'USER_CENTER_INVALID',
        defaultMessage: 'The user must contain only letters (without numbers or special characters)'
    },
    EMAIL_CENTER_PLACEHOLDER: {
        id: 'EMAIL_CENTER_PLACEHOLDER',
        description: 'EMAIL_CENTER_PLACEHOLDER',
        defaultMessage: 'e.g., mperez@cosentino.com'
    },
    USER_CENTER_PLACEHOLDER: {
        id: 'USER_CENTER_PLACEHOLDER',
        description: 'USER_CENTER_PLACEHOLDER',
        defaultMessage: 'e.g., MPEREZ'
    },
    USER_CENTER_TOO_LONG: {
        id: 'USER_CENTER_TOO_LONG',
        description: 'USER_CENTER_TOO_LONG',
        defaultMessage: 'The user cannot exceed 10 characters'
    },
})
class AddAccountCenterForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            status: '',
            msg: '',
            show: false
        }
    }
    validateForm() {
        const emailVal = this.emailInput.value.trim();
        const userVal = this.userInput.value.trim();

        // Regex: solo letras (sin números ni especiales)
        const userRegex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ]+$/;

        // Regex: formato email válido + dominio @cosentino.com
        const emailRegex = /^[a-zA-Z0-9._%+-]+@cosentino\.com$/;

        if (userVal === '') {
            this.emptyForm();
            this.setState({ show: true, status: 'warning', msg: 'USER_CENTER_NOT_EMPTY' });
            return false;
        }

        if (!userRegex.test(userVal)) {
            this.emptyForm();
            this.setState({ show: true, status: 'warning', msg: 'USER_CENTER_INVALID' });
            return false;
        }

        if (userVal.length > 10) {
            this.emptyForm();
            this.setState({ show: true, status: 'warning', msg: 'USER_CENTER_TOO_LONG' });
            return false;
        }

        if (emailVal === '') {
            this.emptyForm();
            this.setState({ show: true, status: 'warning', msg: 'EMAIL_CENTER_NOT_EMPTY' });
            return false;
        }

        if (!emailRegex.test(emailVal)) {
            this.emptyForm();
            this.setState({ show: true, status: 'warning', msg: 'EMAIL_CENTER_IS_NOT_FORMAT' });
            return false;
        }

        this.setState({ show: false });
        return true;
    }
    emptyForm() {
        this.emailInput.value = '';
        this.userInput.value = '';
    }

    handleSubmit = e => {
        e.preventDefault()
        if (this.validateForm()) {
            this.props.onAddEmailCenter(this.userInput.value, this.emailInput.value)
            this.emptyForm();
        }
    }
    render() {
        return (
            <div className="form-signin">
                <form onSubmit={this.handleSubmit}>

                    <label htmlFor="inputUser">
                        <Translation id="USER_CENTER_LABEL" defaultMessage="Name of the SAP account linked to the user" />
                    </label>
                    <input
                        type="text"
                        id="inputUser"
                        className="form-control"
                        placeholder={this.props.intl.formatMessage({ id: 'USER_CENTER_PLACEHOLDER' })}
                        ref={node => {
                            this.userInput = node
                        }}
                    />

                    <label htmlFor="inputEmail">
                        <Translation id="EMAIL_CENTER_LABEL" defaultMessage="Corporate email address of Cosentino. Must follow the format: SAPaccount@cosentino.com" />
                    </label>
                    <input
                        type="text"
                        id="inputEmail"
                        className="form-control"
                        placeholder={this.props.intl.formatMessage({ id: 'EMAIL_CENTER_PLACEHOLDER' })}
                        ref={node => {
                            this.emailInput = node
                        }}
                    />

                    {this.state.show && (
                        <div className="mb-2">
                            <Alerts status={this.state.status} alert={this.state.msg} />
                        </div>
                    )}

                    <input type="submit" className="bt bt-inverted button" value={this.props.intl.formatMessage({ id: 'add' })} />
                </form>
            </div>
        )
    }
}
export default injectIntl(AddAccountCenterForm)
